<ng-container *ngIf="photos | async as photos">

    <div class="content">
      <div class="gallery">
        <div class="galleryimg"  *ngFor="let p of photos">
          <a [routerLink]="'./' + p.key">
              <app-image [baseUrl]="p.image.baseUrl"></app-image>
          </a>
        </div>
      </div>
    </div>
  </ng-container>
  
  <ng-container *ngIf="bookplate | async as bookplate">

    <div class="content">
      <div class="gallery">
        <div class="galleryimg"  *ngFor="let b of bookplate">
          <a [routerLink]="'./' + b.key">
              <app-image [baseUrl]="b.image.baseUrl"></app-image>
          </a>
        </div>
      </div>
    </div>
  </ng-container>
  